import api from "./api";

const inFlightTicketRequests = new Map();
let requestGeneration = 0;

const normalizeForKey = (value) => {
  if (Array.isArray(value)) {
    return value.map(normalizeForKey);
  }

  if (value && typeof value === "object") {
    return Object.keys(value)
      .sort()
      .reduce((normalized, key) => {
        const normalizedValue = normalizeForKey(value[key]);
        if (normalizedValue !== undefined) {
          normalized[key] = normalizedValue;
        }
        return normalized;
      }, {});
  }

  return value;
};

const buildRequestKey = (config) =>
  JSON.stringify({
    generation: requestGeneration,
    params: normalizeForKey(config?.params || {}),
    timeout: config?.timeout,
  });

export const getTickets = (config = {}) => {
  const requestKey = buildRequestKey(config);
  const currentRequest = inFlightTicketRequests.get(requestKey);

  if (currentRequest) {
    return currentRequest;
  }

  const request = api.get("/tickets", config).finally(() => {
    if (inFlightTicketRequests.get(requestKey) === request) {
      inFlightTicketRequests.delete(requestKey);
    }
  });

  inFlightTicketRequests.set(requestKey, request);
  return request;
};

const inFlightTicketByIdRequests = new Map();

export const getTicketById = (ticketId, config = {}) => {
  const numericId = Number(ticketId);
  if (!Number.isFinite(numericId) || numericId <= 0) {
    return Promise.reject(new Error("Invalid ticket ID"));
  }

  const cacheKey = `ticket:${numericId}`;
  const inFlight = inFlightTicketByIdRequests.get(cacheKey);
  if (inFlight) {
    return inFlight;
  }

  const request = api.get(`/tickets/${numericId}`, config).finally(() => {
    setTimeout(() => {
      if (inFlightTicketByIdRequests.get(cacheKey) === request) {
        inFlightTicketByIdRequests.delete(cacheKey);
      }
    }, 1500);
  });

  inFlightTicketByIdRequests.set(cacheKey, request);
  return request;
};

if (typeof window !== "undefined") {
  window.addEventListener("tickets:changed", () => {
    requestGeneration += 1;
    inFlightTicketByIdRequests.clear();
  });
}
